import type { ResonancePhase } from '../game/simulation/dropBag';

/** One MOSS-generated fusion sound per active resonance, independent of character or chain. */
export const EVOLUTION_ASSETS = [
  'evolution-phase-1',
  'evolution-phase-2',
  'evolution-phase-3',
  'evolution-phase-4',
  'evolution-phase-5',
] as const;

export type EvolutionAssetKey = (typeof EVOLUTION_ASSETS)[number];
export type EvolutionSoundKey = EvolutionAssetKey;

export function evolutionKey(phase: ResonancePhase): EvolutionAssetKey {
  return EVOLUTION_ASSETS[phase - 1]!;
}
